import { UserX, Home, LogIn } from 'lucide-react'
import { Link } from 'react-router-dom'

interface ProfileNotFoundProps {
  username?: string
}

export default function ProfileNotFound({ username }: ProfileNotFoundProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
      <div className="container-custom py-12">
        <div className="card max-w-2xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center">
              <UserX className="w-12 h-12 text-gray-400" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Profile Not Found
          </h1>

          <p className="text-lg text-gray-700 mb-8">
            {username ? (
              <>
                We couldn&apos;t find a profile with the username{' '}
                <span className="font-semibold">&quot;{username}&quot;</span>
              </>
            ) : (
              <>
                The profile you&apos;re looking for doesn&apos;t exist or has
                been removed.
              </>
            )}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn-primary inline-flex items-center gap-2">
              <Home className="w-5 h-5" />
              Go to Homepage
            </Link>

            <Link
              to="/login"
              className="btn-secondary inline-flex items-center gap-2"
            >
              <LogIn className="w-5 h-5" />
              Sign In
            </Link>
          </div>

          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Looking for someone? Try searching for candidates on our platform.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
